class ProductGalleryMobileCarousel extends HTMLElement {
  connectedCallback() {
    this.breakpoint = window.matchMedia('(max-width: 989px)');
    this.track = this.querySelector('[data-gallery-track]');
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.currentLabel = this.querySelector('[data-gallery-current]');
    this.currentIndex = 0;

    if (!this.track || this.slides.length <= 1) return;

    this.onScroll = this.handleScroll.bind(this);
    this.onResize = this.syncToCurrent.bind(this);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => this.goTo(index));
    });

    this.updateUi(0);
  }

  disconnectedCallback() {
    if (this.track && this.onScroll) {
      this.track.removeEventListener('scroll', this.onScroll);
    }

    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  handleScroll() {
    if (!this.breakpoint.matches) return;

    const slideWidth = this.track.clientWidth;
    if (!slideWidth) return;

    const nextIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / slideWidth)));

    if (nextIndex !== this.currentIndex) {
      this.updateUi(nextIndex);
    }
  }

  goTo(index) {
    const slide = this.slides[index];
    if (!slide) return;

    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: this.breakpoint.matches ? 'smooth' : 'auto',
    });

    this.updateUi(index);
  }

  syncToCurrent() {
    if (!this.breakpoint.matches) return;
    this.goTo(this.currentIndex);
  }

  updateUi(index) {
    this.currentIndex = index;

    if (this.currentLabel) {
      this.currentLabel.textContent = String(index + 1);
    }

    this.thumbs.forEach((thumb, thumbIndex) => {
      if (thumbIndex === index) {
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('product-gallery-mobile-carousel')) {
  customElements.define('product-gallery-mobile-carousel', ProductGalleryMobileCarousel);
}
